import { API_ROOT } from "config.js";

const USER_WIDGETS_LIST_ENDPOINT = `${API_ROOT}/api/widgets/`;

export async function getUserWidgets(
  axios,
  userId = null,
  weekOffset = 0,
  options = {}
) {
  let url = USER_WIDGETS_LIST_ENDPOINT;
  const params = [];
  if (userId != null) {
    params.push(`userId=${userId}`);
  }
  if (weekOffset !== 0) {
    params.push(`weekOffset=${weekOffset}`);
  }
  if (options.forcePerformanceMetrics || options.forceMarathonShape) {
    params.push("forcePerformanceMetrics=1");
  }
  if (params.length) {
    url = `${url}?${params.join("&")}`;
  }
  const response = await axios.get(url);
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  const data = response.data;
  return data;
}

export async function updateTrainingPlanForDay(
  axios,
  day,
  title,
  description,
  userId = null
) {
  const payload = {
    day,
    title,
    description
  };

  if (userId != null) {
    payload.user_id = userId;
  }

  const response = await axios.patch(
    `${USER_WIDGETS_LIST_ENDPOINT}training-day/`,
    payload
  );
  if (response.status < 200 || response.status >= 300) {
    throw new Error(response.statusText);
  }
  return response.data;
}
